import type { GridRowId } from '@mui/x-data-grid';

interface PartitionRow {
  unitNumberAmbiguity?: boolean;
}

export const partitionBulkAction = (
  action: 'approve' | 'reject',
  selected: ReadonlyArray<GridRowId>,
  byId: ReadonlyMap<string, PartitionRow>,
): { ambiguousIds: Array<GridRowId>; submittedIds: Array<string> } => {
  const ambiguousIds = action === 'approve' ? selected.filter((id) => byId.get(String(id))?.unitNumberAmbiguity) : [];
  const submittedIds = selected.filter((id) => !ambiguousIds.includes(id)).map(String);
  return { ambiguousIds, submittedIds };
};
